<div class="status-filter">
  <span class="filter-label">Status</span>
  @for (option of options; track option.value) {
    <button
      type="button"
      class="pill"
      [attr.data-status]="option.value"
      [class.on]="option.value === selected()"
      (click)="select(option.value)"
    >
      {{ option.label }}
    </button>
  }
</div>
